/**
 * Adapts the pixel-world zustand store to the bridge's VisualizationTarget seam.
 *
 * The store's actions are stable (they close over zustand's `set`), so reading them
 * once via getState() is safe. A different renderer would provide its own
 * VisualizationTarget here instead.
 */

import { usePixelWorldStore } from "../state/PixelWorldStore.js";
import type { VisualizationTarget } from "./types.js";

export function createStoreTarget(
  store: typeof usePixelWorldStore = usePixelWorldStore,
): VisualizationTarget {
  const s = store.getState();
  return {
    setScene: s.setScene,
    reset: s.reset,
    setAgentStatus: s.setAgentStatus,
    enqueueMessage: s.enqueueMessage,
  };
}
